let formatPhone = (phone, country_code = 'US') => {
  const cleaned = phone.replace(/\D/g, '');

  switch (country_code) {
    case 'US':
    case 'CA':
      if (cleaned.length === 10) {
        return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
      }
      break;
    case 'AU':
      if (cleaned.length === 10 && cleaned.startsWith('0')) {
        return `${cleaned.slice(0, 4)} ${cleaned.slice(4, 7)} ${cleaned.slice(7)}`;
      }
      break;
  }
  return phone; // Return original if can't format
};

const COUNTRY_CALLING_CODES = {
  US: '1',
  CA: '1',
  AU: '61',
  BM: '1',
  IN: '91',
  GB: '44',
  NZ: '64',
  IE: '353',
};

// Strip the shop country's calling code so a number reads the way phone
// numbers are stored ("+1 (555) 000-9999" -> "5550009999").
let localPhoneDigits = (phone, country_code = 'US') => {
  const country = String(country_code || 'US').toUpperCase();
  const digits = String(phone || '').replace(/\D/g, '');
  const callingCode = COUNTRY_CALLING_CODES[country];

  if (callingCode && digits.startsWith(callingCode)) {
    const localDigits = digits.slice(callingCode.length);

    if (country === 'AU' && localDigits.length === 9) {
      return '0' + localDigits;
    }

    return localDigits;
  }

  return country === 'US' || country === 'CA' || country === 'BM' ? digits.slice(-10) : digits;
};

export { formatPhone, localPhoneDigits };
